import {css} from 'aphrodite';
import React from 'react';

import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import ProcedurePageLinkForProcedureRun from 'procedures/ProcedurePageLinkForProcedureRun';
import getProcedureReplicateNames from 'procedures/utils/getProcedureReplicateNames';
import getProcedureRunConditionNames from 'procedures/utils/getProcedureRunConditionNames';
import {UpdateTaskParams} from 'processes/process-task-details/utils/updateTaskDetailsTask';
import {ChipSize} from 'ui-library/chips/Chip';
import ProcessTaskChip from 'ui-library/chips/ProcessTaskChip';

import FormattedTextField from '../fields/FormattedTextField';
import PlaceholderFieldValue from '../fields/PlaceholderFieldValue';
import {getProceduresUnitOperationTaskDetailsSummaryRows} from '../procedures/getProceduresUnitOperationTaskDetailsSections';
import {
  ProcessTaskDetailsRowContent,
  PROCESS_TASK_DETAILS_PAGE_STYLES,
  PROCESS_TASK_DETAILS_LABELS,
  ProcessTaskGql,
} from '../ProcessTaskDetailsPageConstants';

export function getAssayUnitOperationTaskDetailsSummaryRows(
  processTask: ProcessTaskGql,
  onUpdateTask: (updatedTask: UpdateTaskParams) => Promise<void>
): Array<ProcessTaskDetailsRowContent> {
  const methodExecutionInstance = processTask.procedureMethodExecutionInstance;
  let conditionsDisplayString = null;
  let procedureRun = null;
  let replicateDisplayString = null;
  if (methodExecutionInstance != null && !isInaccessible(methodExecutionInstance)) {
    procedureRun = methodExecutionInstance.procedureRun;
    conditionsDisplayString = getProcedureRunConditionNames(methodExecutionInstance);
    replicateDisplayString = getProcedureReplicateNames(methodExecutionInstance);
  }

  return getProceduresUnitOperationTaskDetailsSummaryRows(processTask, onUpdateTask, {
    experimentRunContent: {
      label: PROCESS_TASK_DETAILS_LABELS.ASSAY_EXPERIMENT_RUN,
      component:
        processTask.rootTask != null ? (
          <ProcessTaskChip
            id={processTask.rootTask.id}
            className={css(PROCESS_TASK_DETAILS_PAGE_STYLES.chipHeight)}
            size={ChipSize.TABLE_CELL}
          />
        ) : (
          <PlaceholderFieldValue />
        ),
    },
    procedureTemplateContent: {
      label: PROCESS_TASK_DETAILS_LABELS.ASSAY_TEMPLATE,
      component:
        procedureRun != null ? (
          <ProcedurePageLinkForProcedureRun
            procedureRun={procedureRun}
            className={css(PROCESS_TASK_DETAILS_PAGE_STYLES.rowHeight)}
          />
        ) : (
          <PlaceholderFieldValue />
        ),
    },
    conditionsContent: {
      label: PROCESS_TASK_DETAILS_LABELS.ASSAY_CONDITIONS,
      component: conditionsDisplayString ? (
        <FormattedTextField text={conditionsDisplayString} />
      ) : (
        <PlaceholderFieldValue />
      ),
    },
    replicatesContent: {
      label: PROCESS_TASK_DETAILS_LABELS.ASSAY_REPLICATE,
      component: replicateDisplayString ? (
        <FormattedTextField text={replicateDisplayString} />
      ) : (
        <PlaceholderFieldValue />
      ),
    },
  });
}
